module.exports = __webpack_public_path__ + "img/userB22.29136d3f.jpg";